module.exports = __webpack_public_path__ + "static/img/TK.3daf10e5.svg";